import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { ACTION_STATUS } from "constants/actions";
import { ACTION_VIEW_MODE } from "constants/action-form";
import Title from "../../../Typography/Title";
import DetailSection from "../DetailSection";
import DateSpan from "../date-span/DateSpan";
import QuantityInput from "../../../action-inputs/quantity/QuantityInput";
import useAvailableQuantityUnits from "../../utils/useAvailableOperationUnits";
import ActionModalDescriptionSection from "../description/ActionModalDescriptionSection";
import BioSelectionInput from "components/action-inputs/bio-selection/BioSelectionInput";
import FertilizerInput from "components/action-inputs/fertilizer/FertilizerInput";
import FertilizeLimits from "./Limits";

const FertilizeSuggestion = ({
  viewMode,
  isFullWidth,
  isProposedValue,
  fertilizers,
  isNewVersion,
}) => {
  const { t } = useTranslation();

  const { values } = useFormikContext();
  const status = ACTION_STATUS.suggested;
  const isViewMode = viewMode === ACTION_VIEW_MODE.view;

  const { availableQuantityUnits } = useAvailableQuantityUnits(
    values.taskId,
    values.fertilizeAction?.operationTypeId,
  );

  return (
    <div className="action-modal-card action-details-box ">
      <div className={isFullWidth && "details-half-width"}>
        <Title title={t("ActionModal.Details.Suggested")} />
        {!isNewVersion && <DateSpan viewMode={viewMode} status={status} />}
        <DetailSection
          title={t("ActionModal.Fertilizer")}
          isRequired={!isViewMode}
          isNewVersion={isNewVersion}
        >
          <div className="action-details-column-multiple">
            <BioSelectionInput
              task="fertilize"
              isProposed={isProposedValue}
              isViewMode={isViewMode}
            />
            <FertilizerInput
              fertilizers={fertilizers}
              isProposed={isProposedValue}
              isViewMode={isViewMode}
            />
          </div>
        </DetailSection>
        <DetailSection
          title={t("ActionModal.Quantity")}
          isRequired={!isViewMode}
          isNewVersion={isNewVersion}
        >
          <QuantityInput
            task="fertilize"
            isViewMode={isViewMode}
            isProposed={isProposedValue}
            quantityOptions={availableQuantityUnits}
          />
          <FertilizeLimits fertilizers={fertilizers} />
        </DetailSection>
        <ActionModalDescriptionSection
          task="fertilize"
          isViewMode={isViewMode}
          isProposed={isProposedValue}
          isNewVersion={isNewVersion}
        />
      </div>
    </div>
  );
};

export default FertilizeSuggestion;
